let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k3BGs"), load("4JUnA")]).then(() => parcelRequire('11cB0'));